import type { IconDefinition } from "@fortawesome/fontawesome-common-types";

import { IconButton, type IconButtonProps } from "@aviary/components/Button/IconButton";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./AvatarBadge.styles";

interface Props extends Omit<IconButtonProps, "size"> {
  icon: IconDefinition;
}

const AvatarBadge = ({ icon, ...rest }: Props) => {
  return (
    <IconButton css={styles.size} isCircular {...rest}>
      <FontAwesomeIcon icon={icon} size="xs" />
    </IconButton>
  );
};

export { AvatarBadge };
